module.exports = __webpack_public_path__ + "img/2.fb5534e8.png";